import React, { useContext, useEffect, useState } from 'react'
import { __ } from 'i18n-for-browser'
import '../../config/i18n'
import analytics from '../../config/analytics'
import { EasybakeContext } from '../EasybakeProvider'
import Heading from '@react/react-spectrum/Heading'
import Button from '@react/react-spectrum/Button'
import { Accordion, AccordionItem } from '@react/react-spectrum/Accordion'
import '../../style/console.css'
import { setBodyHeight } from '../../lib/easybake'
import ConsoleSteps from './ConsoleSteps'
import WizardProjectInfo from '../Nav/WizardProjectInfo'


export default function CredInfo () {
    const { page, dispatch } = useContext(EasybakeContext)

    useEffect(() => {
        setBodyHeight('adobe-easybake-main-sub-pane')
    }, [])

    function goToNext(e) {
        dispatch({ type: 'set-page', payload: { page: 'accesstoken' } })
    }

    return <div className="adobe-easybake-main-sub-pane">
        <div className="adobe-easybake-main-sub-pane-contents-signup">
            <div className="adobe-easybake-main-sub-pane-header">
                <ConsoleSteps referrer={page}/>
                <Heading variant="pageTitle" className="adobe-easybake-console-title">{__('console_credinfo_title')}</Heading>
                <hr className="adobe-easybake-hr" />
            </div>
            <div className="adobe-easybake-main-contents">
                <WizardProjectInfo />
                <div className="adobe-easybake-flex-row-button-right-aligned">
                    <br />
                    <Button variant="primary" onClick={ e => goToNext(e) }>{__('console_credinfo_btn_next')}</Button>
                </div>
            <br />
            </div>
        </div>
    </div>
}
